module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAKCAYAAABWiWWfAAAA8ElEQVQokY3SPUrEUBwE8F/CghDB3mvEwiPYip2FNjZaCOoWKloqdn4sSrQQRBsrtfQQRlAQPIKFYCEBu1hsFh7ZRHe6mf/MMA9elEuWsII7ZPgyAtKy8ByNT1bZOWRRLnnCVOU5rwpfR+ibxX3A32JcBsIyXjDzT9FWrQiyuFpyWjs8YqGl6AgHNe04LYuzuCKrlSnENdYCPo2rmga7aVmsQycQN/CD7dqKCXzgomHlfFoWtwMS5ZK6YQd7DcEQGXppWbyHYqfBuI9vnLQUHaKblsXQIR72gh4WG/RNdFsyjcsGuMGn/qcc03/awx9+v9VJNl5AwzFHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/jxwx/arr.png
// module id = N/mW
// module chunks = 1